import 'view/css/report.css';

// eslint-disable-next-line
import { Chart as ChartJS } from 'chart.js/auto';   // cannot remove, this 2 lines will register scale for ChartJS
// eslint-disable-next-line
import { Chart }            from 'react-chartjs-2';

import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';

import Util, { Data } from 'service/util';
import Loading from 'component/Loading';
import NoData from 'component/NoData';

import LocationReportTable from 'component/report/LocationReportTable';


class LocCounter
{
  constructor() {
    this.cnt_total    = 0;
    this.cnt_new      = 0;
    this.cnt_newFleet = 0;
    this.cnt_newOther = 0;
    this.cnt_reunion  = 0;
    this.cnt_term     = 0;
    this.cnt_normTerm = 0;
    this.cnt_compTerm = 0;
    this.lic_newFleet = [];
    this.lic_newOther = [];
    this.lic_reunion  = [];
    this.lic_normTerm = [];
    this.lic_compTerm = [];
  }
  add(d) {
    this.cnt_total    += d.cnt_total;
    this.cnt_new      += d.cnt_newFleet + d.cnt_newOther;
    this.cnt_newFleet += d.cnt_newFleet;
    this.cnt_newOther += d.cnt_newOther;
    this.cnt_reunion  += d.cnt_reunion;
    this.cnt_term     += d.cnt_normTerm + d.cnt_compTerm;
    this.cnt_normTerm += d.cnt_normTerm;
    this.cnt_compTerm += d.cnt_compTerm;

    if (d.lic_newFleet) this.lic_newFleet.push(...d.lic_newFleet);
    if (d.lic_newOther) this.lic_newOther.push(...d.lic_newOther);
    if (d.lic_reunion ) this.lic_reunion .push(...d.lic_reunion );
    if (d.lic_normTerm) this.lic_normTerm.push(...d.lic_normTerm);
    if (d.lic_compTerm) this.lic_compTerm.push(...d.lic_compTerm);
  }
  toChartData() {
    return [ this.cnt_total, this.cnt_newFleet, this.cnt_newOther, this.cnt_reunion, this.cnt_normTerm, this.cnt_compTerm ];
  }
}

function createOpt(title) {
  return {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yLeft: {
        position: 'left',
      },
      yRight: {
        position: 'right',
        grid: { drawOnChartArea: false, },
      },
    },
    options: {
      indexAxis: 'x',
    },
    plugins: {
      title: { display: true, text: title, fontSize: 20 },
    }
  };
}

const optrpt = createOpt('過去十二個月各區車輛服務數量統計');
//-------------------------------------
const LocationReportView = ({
  data, defChartData,
  sel_display, sel_company,
  sel_dis, sel_loc, sel_mgt, sel_fleet,
  sel_month, IxMonths
}) =>
{
  let [items,     setItems     ] = useState(null);
  let [total,     setTotal     ] = useState(null);
  let [chartData, setChartData ] = useState(null);

  useEffect(() =>
  {
    // reset display
    setItems(null);
    setChartData(null);

    // exit when not initiated
    if (!data) return;

    const is_graphMode = sel_display == 'graph';

    let ix = IxMonths[sel_month];
    let ls = data.filter(x => {
      if (!is_graphMode && ix != x.ix) return false;
      if (sel_dis && sel_dis != x.srv_dis) return false;
      if (sel_loc && sel_loc != x.srv_loc) return false;
      if (sel_mgt && sel_mgt != x.mgt_dis) return false;
      if (sel_fleet && sel_fleet != x.cd_fleet) return false;
      return true;
    });

    // no data
    if (!ls.length) {
      setItems([]);
      return;
    }

    let dimCount = new Map();
    if (is_graphMode) {
      // insert all months as key
      IxMonths.forEach(ix => dimCount.set(ix, new LocCounter()));
    }

    ls.reduce((r, x) => {
      let dimKey = is_graphMode ? x.ix : `${x.srv_dis}${x.srv_loc}`;
      if (!dimCount.get(dimKey)) dimCount.set(dimKey, new LocCounter());

      (sel_company ? [sel_company] : Data.company.map(c=>c.cd))
        .forEach( comp => {
          let x2 = {
             cnt_total    : x[`${comp}_Total`]   || 0
            ,cnt_newFleet : x[`${comp}_FltNew`]  || 0
            ,cnt_newOther : x[`${comp}_OthNew`]  || 0
            ,cnt_reunion  : x[`${comp}_Reunion`] || 0
            ,cnt_normTerm : x[`${comp}_NrmTerm`] || 0
            ,cnt_compTerm : x[`${comp}_CmpTerm`] || 0
            ,lic_newFleet : x[`${comp}_lic_fltnew`]
            ,lic_newOther : x[`${comp}_lic_othnew`]
            ,lic_reunion  : x[`${comp}_lic_reun`]
            ,lic_normTerm : x[`${comp}_lic_nterm`]
            ,lic_compTerm : x[`${comp}_lic_cterm`]
          }
          dimCount.get(dimKey).add(x2);
        });

    }, null);

    if (is_graphMode)
    {
      // clone chart options
      let chartData = JSON.parse(JSON.stringify(defChartData));
      let d = Array.from(dimCount.keys()).sort().map(k => dimCount.get(k).toChartData());

      // rearrange dimension
      for (let i = 0; i < d[0].length; i++)
      {
        chartData.datasets[i].data = [];
        for (let j = 0; j < d.length; j++)
          chartData.datasets[i].data[j] = d[j][i];
      }
      setItems([]);
      setChartData(chartData);
    } else {
      let total = new LocCounter();
      let items = [];

      let reg = new RegExp('([A-Z]+)([0-9]+)');
      dimCount.forEach((x, loc_key) => {
        let mch = loc_key.match(reg);
        let srv_dis = mch[1];
        let srv_loc = parseInt(mch[2], 10) || 0;
        items.push({ ...x, srv_dis, srv_loc, loc_key, loc_name: Util.getLocationName(loc_key) });
        total.add(x);
      });

      items.sort((a,b) => {
        if (a.srv_dis > b.srv_dis) return  1;
        if (a.srv_dis < b.srv_dis) return -1;
        if (a.srv_loc > b.srv_loc) return  1;
        if (a.srv_loc < b.srv_loc) return -1;
        return 0;
      })

      setItems(items);
      setTotal(total);
      setChartData(null);
    }

  }, [data, sel_display, sel_month, sel_company, sel_dis, sel_loc, sel_mgt, sel_fleet]);

  if (!items)
    return <Loading />
  if ('graph'===sel_display && chartData)
    return <Line redraw data={chartData} options={optrpt}/>
  if (!items.length)
    return <NoData />
  else
    return <LocationReportTable data={items} total={total} />

}

export default LocationReportView;